import mutations from './mutations';
import actions from './actions';

const initialState = {
  state: false,
  message: ''
};

const errors = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default errors;
